import * as ajax from "@/helpers/ajax";

const resultsApi = {
  getResults: () =>
    ajax._fetch(`/search.json${window.location.search}`)
}

export default resultsApi;